import { formatPhone, getAvatarClass, getFuel, getInitials, PLACEHOLDER } from './userAdapter';

/** Pure mapping from the get-profile response to what the profile page renders. */

const PROVIDERS = { google: 'Google', apple: 'Apple', facebook: 'Facebook' };

const FREQUENCIES = {
  monthly_1: 'Once a month',
  monthly_2_3: '2–3× a month',
  weekly: 'Weekly',
  heavy: 'Heavy driver',
};

const humanise = (value) => {
  const text = String(value).replace(/[_-]+/g, ' ').trim();
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : PLACEHOLDER;
};

/** Sign-in method. The backend sends the string "null" for e-mail/password accounts. */
export function getSignInMethod(provider) {
  const key = typeof provider === 'string' ? provider.trim().toLowerCase() : '';
  if (!key || key === 'null' || key === 'undefined') return 'Email & password';
  return PROVIDERS[key] ?? humanise(key);
}

export function getFuelFrequency(value) {
  if (typeof value !== 'string' || !value.trim()) return null;
  return FREQUENCIES[value.trim()] ?? humanise(value);
}

/** Formats "2026-10-07 10:10:43" or ISO dates; returns null if unparseable. */
export function formatDate(value) {
  if (typeof value !== 'string' || !value.trim()) return null;
  const date = new Date(value.includes('T') ? value : value.replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString('en-GB', { dateStyle: 'medium' });
}

/**
 * @param {import('./profileSchema').ProfileDto} p
 */
export function toProfileView(p) {
  const scans = typeof p.scans_made === 'number' ? p.scans_made : null;
  const fuel = getFuel(p.answers?.fuel_type);
  return {
    userId: p.userId,
    name: p.name?.trim() || PLACEHOLDER,
    initials: getInitials(p.name),
    avatarClass: getAvatarClass(p.userId ?? p.id),
    email: p.email?.trim() || null,
    phone: formatPhone(p.phone_number),
    status: p.isActive === true ? 'active' : p.isActive === false ? 'inactive' : 'unknown',
    memberSince: formatDate(p.createdAt),
    signInMethod: getSignInMethod(p.provider),
    fuel,
    fuelFrequency: getFuelFrequency(p.answers?.fuel_frequency),
    onboardingQuiz: p.has_answered === true ? 'Completed' : p.has_answered === false ? 'Not completed' : PLACEHOLDER,
    scans,
  };
}
